import * as InstrumentTestsConstants from './InstrumentTestsConstants';
import { produce } from "immer";
const assign = Object.assign || require('object.assign');


// The initial application state
const initialState = {};

export default function InstrumentTestsReducer(state = initialState, action) {
    switch (action.type) {
        case InstrumentTestsConstants.INSTRUMENT_TESTS_DEVICE_STATE_ADD: {
            if (state[action.payload]) {
                return state;
            }

            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isInstTestsDataFetching: false,
                    isInstTestsDataFetched: false,
                    isInstTestsDataFailed: false,
                    instTests: {}
                };
            });
            return assign({}, state, newState);
        }
        case InstrumentTestsConstants.INSTRUMENT_TESTS_DEVICE_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }
        case InstrumentTestsConstants.INSTRUMENT_TESTS_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isInstTestsDataFetching: true,
                    isInstTestsDataFetched: false,
					isInstTestsDataFailed: false
                }
            });
            return assign({}, state, newState);
        }
        case InstrumentTestsConstants.INSTRUMENT_TESTS_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isInstTestsDataFetching: false,
                    isInstTestsDataFetched: true,
					isInstTestsDataFailed: false,
                    instTests: action.payload.newState
                }
            });
            return assign({}, state, newState);
        }
        case InstrumentTestsConstants.INSTRUMENT_TESTS_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isInstTestsDataFetching: false,
                    isInstTestsDataFetched: false,
                    isInstTestsDataFailed: true
                }
            });
            return assign({}, state, newState);
        }
        default:
            return state;
    }
}
